import { useEffect } from 'react';

import { useMaintenanceFlag } from '@revelio/core';
import type { ToastId } from '@revelio/ui';

import { useToast } from '../hooks/useToast';

export const MaintenanceToast = () => {
  const { isOn: maintenanceOn, message: maintenanceMessage } =
    useMaintenanceFlag();
  const toast = useToast();

  useEffect(() => {
    let id: ToastId;
    if (maintenanceOn) {
      id = toast({
        title: 'Site Under Maintenance',
        description: maintenanceMessage,
        status: 'error',
        duration: null,
        position: 'top-right',
        isClosable: true,
      });
    }
    return () => {
      id && toast.close(id);
    };
  }, [toast, maintenanceOn, maintenanceMessage]);
  return null;
};
